import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useFilters } from '@/context/filters-context';
import { usePage } from '@inertiajs/react';
import { type SharedData } from '@/types';

export const LocationFilter = () => {
    const { filters, setFilters } = useFilters();
    const { brand } = usePage<SharedData>().props;

    if (brand.is_hyperlocal && brand.neighborhoods?.length) {
        return (
            <div>
                <Label htmlFor="neighborhood-select">Neighborhood</Label>
                <select
                    id="neighborhood-select"
                    className="mt-1 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring"
                    value={filters.location.neighborhoodId}
                    onChange={(e) =>
                        setFilters((prev) => ({
                            ...prev,
                            location: { ...prev.location, neighborhoodId: e.target.value },
                        }))
                    }
                >
                    <option value="">All neighborhoods</option>
                    {brand.neighborhoods.map((n) => (
                        <option key={n.id} value={String(n.id)}>
                            {n.name}
                        </option>
                    ))}
                </select>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            <div>
                <Label htmlFor="city-input">City</Label>
                <Input
                    id="city-input"
                    value={filters.location.city}
                    onChange={(e) =>
                        setFilters((prev) => ({
                            ...prev,
                            location: { ...prev.location, city: e.target.value },
                        }))
                    }
                    placeholder="e.g. Amsterdam"
                    className="mt-1"
                    autoComplete="off"
                />
            </div>
            <div>
                <Label htmlFor="region-input">Region</Label>
                <Input
                    id="region-input"
                    value={filters.location.region}
                    onChange={(e) =>
                        setFilters((prev) => ({
                            ...prev,
                            location: { ...prev.location, region: e.target.value },
                        }))
                    }
                    placeholder="e.g. Noord-Holland"
                    className="mt-1"
                    autoComplete="off"
                />
            </div>
        </div>
    );
};
